import { Resource } from '../../shared/resource';

export class QuickbooksCompany extends Resource {
  id!: string;
  organization!: string;
  owner!: string;
  filePath!: string;
};
